import request from '@/config/axios'

const BASE = '/hotel/platform/settlement'

export interface HotelPlatformShopOption {
  id: string | number
  name: string
  operationMode: string
  settleCycle: string
  autoSettle: number
}

export const getHotelOptions = () =>
  request.get<HotelPlatformShopOption[]>({ url: '/hotel/platform/shop/simple-list' })
export const getSettlementBatchPage = (params: any) => request.get({ url: `${BASE}/page`, params })
export const getSettlementDetailPage = (params: any) =>
  request.get({ url: `${BASE}/detail/page`, params })
export const executeSettlement = (shopId: string | number, cutoffTime?: string) =>
  request.post({ url: `${BASE}/execute`, params: { shopId, cutoffTime } })
export const retrySettlement = (id: string | number) =>
  request.post({ url: `${BASE}/retry`, params: { id } })
